<template>
  <div class="relative">
    <i
      class="h-full w-10 absolute z-10 top-0 left-0 flex items-center justify-center text-secondary-200"
      ><BaseIcon name="lens" size="sm"
    /></i>
    <input
      ref="inputSearch"
      type="text"
      autocomplete="off"
      @blur="toggleWidth"
      :class="[custom, sizeClasses, utilityClasses, setWidth]"
      class="form-input custom-animate-width px-8"
      v-bind="$attrs"
      v-on="listeners"
      @keyup.enter="manualSearch"
    />
    <button
      aria-label="Búsqueda manual"
      @click="manualSearch"
      class="rounded w-10 hover:bg-primary-10 hover:text-primary focus:text-primary active:text-blue-700 absolute z-10 top-0 right-0 flex items-center justify-center text-secondary-200 h-full focus:outline-none"
    >
      <base-icon name="enter" size="sm" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'base-input-search',
  inheritAttrs: false,
  props: {
    size: {
      type: String,
      default: 'md'
    },
    align: {
      type: String,
      default: 'left'
    },
    custom: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      holdWidth: false
    }
  },
  computed: {
    sizeClasses: function () {
      return {
        'h-8 py-1 text-sm': this.size === 'xs',
        'h-10': this.size === 'md'
      }
    },
    utilityClasses: function () {
      return {
        'text-center': this.align === 'center'
      }
    },
    listeners: function () {
      return {
        ...this.$listeners,
        input: event => {
          this.$emit('input', event.target.value)
        }
      }
    },
    attrs: function () {
      return {
        ...this.$attrs
      }
    },
    setWidth: function () {
      return (this.holdWidth ? 'w-full md:w-52' : 'lg:w-28 xl:w-52 lg:focus:w-52 lg:active:w-52')
    }
  },
  methods: {
    manualSearch: function () {
      this.$emit('manualSearch', this.$refs.inputSearch.value)
    },
    toggleWidth: function (event) {
      const val = event.target.value
      if (val) {
        this.holdWidth = true
      } else {
        this.holdWidth = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-animate-width {
  will-change: width;
  transition: all 0.2s ease;
}
</style>
